import React, { useMemo, useState, useEffect } from "react";
import SearchBar from "../../../components/Elements/Search/SearchBar";
import CustomButton from "../../../components/Elements/Buttons/CustomButtons";
import { Tables } from "../../../components/Elements/Tables/Tables";
import { ReactComponent as EyeIcon } from "../../../assets/svgs/greenEye.svg";
import { ReactComponent as DownloadIcon } from "../../../assets/svgs/download-icon.svg";
import { Badge } from "../../../components/Elements/TextStyles/Badge";
import ProjectReportFilter from "../DailogBoxes/ProjectReportFilter";
import ProjectsReportsView from "../DailogBoxes/ProjectsReportsView";

import { API_URLS } from "../../../api/apiUrls";
import { getApi } from "../../../api/api_instance";

const ProjectsReport = ({ projectId, clientId }) => {
  console.log(projectId, clientId, " projectId, clientId");

  const [tableData, setTableData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortBy, setSortBy] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const [generateReport, setGenerateReport] = useState(false);
  // const [viewReportOpen, setViewReportOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 5;
  const [totalRecords, setTotalRecords] = useState(0);
  const [filterOpen, setFilterOpen] = useState(false);
  const [seacrhItem, setSearchItem] = useState("");
  const [status, setStatus] = useState("");
  const [openReportView, setOpenReportView] = useState(false);

  const headers = useMemo(() => [
    { label: "Sr. No.", key: "serial" },
    { label: "Name", key: "name" },
    { label: "Project Name", key: "projectName" },
    { label: "Requested Date", key: "requested_date" },
    { label: <div className="px-10">Status</div>, key: "status" },
    { label: "Action", key: "action" },
  ], []);

  const STATUS_DISPLAY = {
    in_process: "In Process",
    completed: "Completed",
    rejected: "Rejected",
  };

  const getStatusStyles = (status) => {
    switch (status) {
      case "in_process":
        return {
          backgroundColor: "#45827659",
          color: "#000000",
          border: "1px solid #06513D",
        };
      case "completed":
        return {
          backgroundColor: "#E8C45859",
          color: "#000000",
          border: "1px solid #E8C458",
        };
      case "rejected":
        return {
          backgroundColor: "#6AA4F759",
          color: "#000000",
          border: "1px solid #6AA4F7",
        };
      default:
        return {
          backgroundColor: "#F3F4F6",
          color: "#374151",
          border: "1px solid #374151",
        };
    }
  };

  const handleSearch = (value) => {
    setSearchTerm(value);
    setCurrentPage(1); // Reset to page 1 on search
  };

  const handleSort = (key, order) => {
    setSortBy(key);
    setSortOrder(order);
  };

 const handleViewReport = (item) => {
  setSelectedReport(item);
  setOpenReportView(true);
};

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return `${String(date.getDate()).padStart(2, "0")}-${String(
      date.getMonth() + 1,
    ).padStart(2, "0")}-${date.getFullYear()}`;
  };

  const fetchReports = async () => {
    // Add validation to prevent API call with invalid data
    if (!clientId || !projectId) {
      console.warn("Missing required parameters: clientId or projectId");
      return;
    }

    setLoading(true);
    try {
      console.log(clientId, "clientIdclientId");
      const response = await getApi({
        apiUrl: API_URLS.GET_ALL_REPORTS(
          currentPage,
          pageSize,
          searchTerm,
          projectId,
          clientId,
        ),
      });

      console.log("API Response:", response);

      if (response?.success && response?.data) {
        // Set pagination data
        if (response.pagination) {
          setTotalRecords(response.pagination.totalRecords);
        }

        // Map table data
        const mappedData = response.data.map((item, index) => ({
          key: item._id,
          serial: (
            <div className="text-center">
              {(currentPage - 1) * pageSize + index + 1}
            </div>
          ),
          name: <div className="text-center">{item.report?.name || "N/A"}</div>,
          requested_date: (
            <div className="text-center">{formatDate(item.requested_on)}</div>
          ),
          projectName:<div className="text-center">{item.project?.name || "N/A"}</div>,
          status: (
            <div className="flex justify-center">
              <button
                className="w-[100px] h-[28px] rounded-lg text-xs font-medium"
                style={getStatusStyles(item.status)}
              >
                {STATUS_DISPLAY[item.status] || item.status}
              </button>
            </div>
          ),
          action: (
            <div className="flex justify-center gap-3">
              <EyeIcon
                className="cursor-pointer"
                onClick={ () => handleViewReport(item)}
              />
            </div>
          ),
          originalData: item,
        }));

        setTableData(mappedData);
      } else {
        setTableData([]);
        setTotalRecords(0);
      }
    } catch (error) {
      console.error("Failed to fetch reports:", error);
      setTableData([]);
      setTotalRecords(0);
    } finally {
      setLoading(false);
    }
  };

  // ✅ FIX: Added all dependencies to useEffect
  useEffect(() => {
    fetchReports();
  }, [currentPage, searchTerm, projectId, clientId]);

  const handlePageChange = (page) => {
    console.log("Page changed to:", page);
    setCurrentPage(page);
  };

  return (
    <div>
      <div className="flex justify-between mx-10">
        <div className="flex gap-8 font-medium">
          <p className="text-[#06513D] pt-2 text-lg">Report</p>
          <SearchBar width="300px" onSearch={handleSearch} />
        </div>
        <div>
          <CustomButton
            buttonType={"primary"}
            variant={"ok"}
            buttonText={"Filter"}
            className={"w-32 py-6 text-[16px]"}
            onClick={() => setFilterOpen(true)}
          />
        </div>
      </div>

      <Tables
        data={tableData}
        headers={headers}
        current={currentPage}
        pageSize={pageSize}
        total={totalRecords}
        onChange={handlePageChange}
        sortBy={sortBy}
        sortOrder={sortOrder}
        onSort={handleSort}
        loading={loading}
      />

      {filterOpen && (
        <ProjectReportFilter
          onOpen={filterOpen}
          onClose={() => setFilterOpen(false)}
          setStatus={setStatus}
        />
      )}

      {openReportView && (
        <ProjectsReportsView
          onOpen={openReportView}
          onClose={() => setOpenReportView(false)}
          reportData={selectedReport}
          reportId={selectedReport?._id}
        />
      )}
    </div>
  );
};

export default ProjectsReport;